import React, { useEffect, useRef, useState } from 'react';
import styles from './Component/CSS/SimilarSection.module.css';
import { useSimilarAudios } from '../hooks/useAudiosHooks';
import Loading from '../common/HousGlass Loader/Loading';
import { useNavigate } from 'react-router-dom';

const SimilarSection = ({ audioData }) => {
  const scrollContainerRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);
  const navigate=useNavigate()
  const { data: similarAudiosData, isLoading, error } = useSimilarAudios(audioData?.id);
  

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll);
      return () => container.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const handleScroll = () => {
    const container = scrollContainerRef.current;
    if (container) {
      const maxScroll = container.scrollWidth - container.clientWidth;
      const currentScroll = container.scrollLeft;
      const progress = (currentScroll / maxScroll) * 100;
      setScrollProgress(progress);
    }
  };

  const handleItemClick = (id) => {
    const container = scrollContainerRef.current;
    const element = container.querySelector(`#series-${id}`);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
    navigate(`/audio/${id}`);
  };

  const handleViewAll = (e) => {
    e.preventDefault();
    const container = scrollContainerRef.current;
    if (container) {
      container.scrollTo({
        left: container.scrollWidth,
        behavior: 'smooth'
      });
    }
  };

  if (isLoading) {
    return <div className={styles.loadingContainer}><Loading /></div>;
  }

  if (error) {
    return <div className={styles.errorMessage}>Failed to load similar audios.</div>;
  }

  // If no similar audios or data not available
  if (!similarAudiosData || !similarAudiosData.data || similarAudiosData.data.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <h2 className={styles.title}>Similar Audios</h2>
        
      </div>

      <div className={styles.scrollContainer} ref={scrollContainerRef}>
        <div className={styles.seriesGrid}>
          {similarAudiosData.data.map((item) => (
            <div
              key={item.id}
              id={`series-${item.id}`}
              className={styles.seriesItem}
              onClick={() => handleItemClick(item.slug)}
            >
              <img
                src={item.mobile_image_url || item.computer_image_url}
                alt={item.title}
                className={styles.seriesImage}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>

      <div className={styles.progressBar}>
        <div
          className={styles.progressIndicator}
          style={{ width: `${scrollProgress}%` }}
        />
      </div>
    </div>
  );
};

export default SimilarSection;